<template>
  <div class="columns is-multiline pdt-0 pdh-0 mg-0">
    <div class="account column is-narrow mgr-0 pdt-0 pdr-0">
      <avatar
        :username="message.creatorName"
        :size="33"
        :src="message.userLogo"/>
    </div>
    <div class="column columns is-multiline pdr-5">
      <div class="column is-12 columns mgv-0 pdv-0">
        <p class="column pdv-0">
          <span class="has-text-weight-bold">
            {{ message.creatorName }}
          </span>
          <span class="is-italic">
            - {{ moment(message.creationTime).format(' D MMMM ' + $t('general.a') + ' HH[h]mm')}}
          </span>
        </p>
      </div>
      <div
        v-if="isAuthor && isModified"
        class="column is-12 is-multiline pdv-0 mgt-0">
        <qd-loader class="mt-3" :active="isLoading">
          <b-field :message="validateInput ? $t('gestionMessage.error.emptyString') : ''"
          :type="validateInput ? 'is-danger' : ''">
            <b-input
              class="no-resize pdv-0"
              v-model="message.message"
              type="textarea"
              :rows="getRows"/>
          </b-field>
        </qd-loader>
        <div
          class="mt-3"
          :class="{
            'is-invisible': !isModified,
          }">
          <div class="buttons">
            <qd-button type="is-addOrEdit" @click="sauvegarder()">
              {{ $t('gestionMessage.button.enregistrer') }}
            </qd-button>
            <qd-button @click="annuler()">
              {{ $t('gestionMessage.button.annuler') }}
            </qd-button>
          </div>
        </div>
      </div>
      <div v-else class="column pdv-0">
        <p class="mgh-3"> {{ message.message }}</p>
        <div
          v-if="isAuthor"
          class="pdt-0"
          :class="{
            'is-invisible': isModified,
          }">
          <a
            class="is-cursor-pointer is-underlined is-size-7 pdh-3"
            @click="isModified = true">
            {{ $t('gestionMessage.button.modifier') }}
          </a>
          <a
            class="is-cursor-pointer is-underlined is-size-7 pdh-3"
            @click="popUpSuppression = true">
            {{ $t('gestionMessage.button.supprimer') }}
          </a>
        </div>
      </div>

      <b-modal
        v-model="popUpSuppression"
        has-modal-card
        class="modal">
        <popUpPrevention
          :messHeader="$t('gestionMessage.messages.prevention')"
          :messagesPopup="messagesErreurPopUp"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="popUpSuppression = false"
          @yes="supprimer"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { update, deleteMessage } from '@/api/gestionMessage';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import { cloneDeep } from 'lodash';
import Avatar from 'vue-avatar';
import moment from 'moment/moment';

const user = createNamespacedHelpers('user');

export default {
  name: 'messageContainer',
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      oldMessage: null,
      popUpSuppression: false,
      messagesErreurPopUp: [],
      timeout: null,
      isLoading: false,
      isModified: false,
    };
  },
  components: {
    popUpPrevention,
    Avatar,
  },
  computed: {
    validateInput() {
      return this.message.message === '';
    },
    moment() {
      return moment;
    },
    isAuthor() {
      return this.utilisateur.id === this.message.creatorUserId;
    },
    ...user.mapGetters({
      utilisateur: 'user',
    }),
    getRows() {
      const rows = this.message.message?.split('\n').length;
      return rows > 3 ? rows : 3;
    },
  },
  methods: {
    annuler() {
      this.message.message = this.oldMessage;
      this.isModified = false;
    },
    async sauvegarder() {
      try {
        this.isLoading = true;
        this.message.message = this.withBr(this.message.message);
        const message = (await update(this.message)).data.result;
        if (message.message === this.message.message) {
          this.message.message = this.noBr(this.message.message);
          this.oldMessage = cloneDeep(this.message.message);
          messageSucces(this.$t('gestionMessage.messages.succesSave'));
        } else {
          this.message.message = this.noBr(this.message.message);
          messageErreur(this.$i18n);
        }
        this.isModified = false;
        this.isLoading = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isLoading = false;
      }
    },
    async supprimer() {
      this.isModified = false;
      this.popUpSuppression = false;
      this.isLoading = true;
      const result = (await deleteMessage(this.message)).data.success;
      if (result === true) {
        this.$emit('deleteMessage', this.message);
        messageSucces(this.$t('gestionMessage.messages.succesSuppression'));
      } else {
        messageErreur(this.$i18n);
      }
      this.isLoading = false;
    },
    noBr(message) {
      return message.replaceAll('<br>', '\n');
    },
    withBr(message) {
      return message.replaceAll('\n', '<br>');
    },
  },
  mounted() {
    try {
      if (this.isAuthor) {
        this.message.message = this.noBr(this.message.message);
      }
      this.oldMessage = cloneDeep(this.message.message);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
